/*
 * @Author: ext.shuiqianning1
 * @Date: 2022-04-24 12:12:50
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-06-14 16:07:47
 * @FilePath: /content-center/src/api/admin.js
 */
import axios from '../utils/axiosAdmin';
import axios1 from "../utils/axios";
const baseUrl = process.env.VUE_APP_BASEURL;
// const baseUrl = '11.18.53.63';

function requestNew(functionId, body) {
  let data = {
    functionId,
    body
  };
  return axios1.request({
    data: data,
    method: "post"
  });
}


// 超管人员信息查询
export function getAdminInfo (body) {
  return requestNew('health_admin_superAdmin_query', body);
}

// 超管权限查询
export function getPremissionList (body) {
  return requestNew('health_admin_superAdmin_listPermission', body);
}

// 菜单管理
export function permissionPage (body) {
  return requestNew('health_admin_permissionMangage_page', body);
}

// 租户管理
export function tenantPage (body) {
  return requestNew('health_admin_contentTenantManage_page', body);
}

// 详情查询
export function tenantDetail (body) {
  return requestNew('health_admin_contentTenantManage_query', body);
}

// 设置租户失效
export function disableContentTenant (body) {
  return requestNew('health_admin_contentTenant_updateStatus', body);
}


// 租户管理员 分页
export function tenantManagerPage (body) {
  return requestNew('health_admin_tenantMangager_page', body);
}

// 增加租户管理员
export function tenantManagerAdd (body) {
  return requestNew('health_admin_tenantMangager_save', body);
}

// 增加租户
export function tenantAdd (body) {
  return requestNew('health_admin_contentTenantManage_save', body);
}

// 冻结租户管理员
export function tenantManagerFreeze (body) {
  return requestNew('health_admin_tenantMangager_freeze', body);
}

// 查询所有菜单
export function listPermissionTree (body) {
  return requestNew('health_admin_permissionMangage_listTree', body);
}

// 查询所有菜单
export function tenantUpdate (body) {
  return requestNew('health_admin_contentTenantManage_update', body);
}

// 内容列表
export function contentTypeUpdate (body) {
  return requestNew('health_admin_contentTypeManage_page', body);
}

// 内容索引分页查询
// 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1159656079
export function contentIndexManagePage(body) {
  return requestNew('health_admin_contentIndexManage_page', body);
}
// 内容索引新增
export function contentIndexManageSave(body) {
  return requestNew('health_admin_contentIndexManage_save', body);
}

// 内容索引修改
export function contentIndexManageUpdate(body) {
  return requestNew('health_admin_contentIndexManage_update', body);
}
// 内容索引删除
export function contentIndexManageDelete(body) {
  return requestNew('health_admin_contentIndexManage_delete', body);
}
// 内容形态新增
export function contentTypeManageSave(body) {
  return requestNew('health_admin_contentTypeManage_save', body);
}